/**
 * Clinical catalog API — doenças, medicamentos e recomendações terapêuticas.
 */

import { apiClient, ApiResponse } from './apiClient';

export interface DiseaseDTO {
  id: string;
  name: string;
  clinicalCode?: string | null;
  summary?: string | null;
  isActive: boolean;
}

export interface PaginatedDTO<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface RecommendationItemDTO {
  recommendationId: string;
  medicationId: string;
  medicationLabel: string;
  brandName?: string | null;
  activeIngredient: string;
  pharmaceuticalForm: string;
  concentration: string;
  administrationRoute: string;
  therapeuticLine?: string | null;
  clinicalNote?: string | null;
  suggestedDose: string;
  suggestedFrequency: string;
  suggestedDurationDays: number;
  standardInstructions?: string | null;
  evidenceLevel?: string | null;
  version: number;
}

export interface DiseaseRecommendationsDTO {
  diseaseId: string;
  diseaseName: string;
  clinicalCode?: string | null;
  disclaimer: string;
  items: RecommendationItemDTO[];
}

export async function searchDiseases(
  search: string,
  page = 1,
  limit = 20,
): Promise<ApiResponse<PaginatedDTO<DiseaseDTO>>> {
  const params = new URLSearchParams();
  if (search.trim()) params.set('search', search.trim());
  params.set('page', String(page));
  params.set('limit', String(limit));
  return apiClient.get(`/clinical/diseases?${params.toString()}`);
}

export async function getDiseaseRecommendations(
  diseaseId: string,
): Promise<ApiResponse<DiseaseRecommendationsDTO>> {
  return apiClient.get(`/clinical/diseases/${diseaseId}/recommendations`);
}
